import {Component, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {BaseGridNoCookieComponent} from 'app/core-ui/abstract/basegrid/basegridnocookie.component';
import {LogService} from 'app/core-ui/abstract/services/log.service';
import {SecurityService} from 'app/core-ui/abstract/services/security.service';
import {VisualsService} from 'app/core-ui/abstract/services/visuals.service';
import {ModalDirective} from 'ngx-bootstrap/modal';
import {FourEyesAdminPanelService} from './fourEyesAdminPanel.service';

@Component({
  selector: 'fourEyesAdminPanel',
  templateUrl: 'fourEyesAdminPanel.component.html',
  providers: [FourEyesAdminPanelService],
})
export class FourEyesAdminPanelComponent extends BaseGridNoCookieComponent<FourEyesAdminPanelService> {
  @ViewChild('detailsModal', {static: false}) public detailsModal: ModalDirective;
  detailsForm: FormGroup;
  modalTitle: string;
  yN = [];
  model = [];
  roles = [];

  constructor(
    private service: FourEyesAdminPanelService,
    securityService: SecurityService,
    logger: LogService,
    visualsService: VisualsService,
    gridService: FourEyesAdminPanelService,
    public fb: FormBuilder,
  ) {
    super(securityService, logger, visualsService, gridService, 'fourEyesAdminPanel');
    this.detailsForm = this.fb.group({
      sfmId: ['', Validators.required],
      foureyesEnabled: ['', Validators.required],
      isSixEyes: ['', Validators.required],
      authRoleId1: ['', Validators.required],
      authRoleId2: ['', Validators.required],
    });
    this.loadVisuals();
    this.yN = this.visualsService.getLkpFromStorageAsJSON('LKP_GENERIC_YN', true);
    this.model = this.visualsService.getLkpFromStorageAsJSON('LKP_FOUREYESADMINPANEL_MODEL', true);
  }

  // column_definition_action
  public rowClick(params: any) {
    this.service.getRoles().subscribe((r) => {
      this.roles = Object.keys(r).map((key) => {
        return {id: key, text: r[key]};
      });
      this.modalTitle = params.description;
      this.detailsForm.controls.sfmId.setValue(params.sfmId);
      this.detailsForm.controls.foureyesEnabled.setValue(params.foureyesEnabled);
      this.detailsForm.controls.isSixEyes.setValue(params.isSixEyes);
      this.detailsForm.controls.authRoleId1.setValue(params.authRoleId1.toString());
      this.detailsForm.controls.authRoleId2.setValue(params.authRoleId2.toString());
      this.detailsModal.show();
    });
  }

  public saveDetails() {
    this.loading = true;
    this.service.update(this.detailsForm.getRawValue()).subscribe({
      next: () => {
        LogService.emitAlert({
          type: 'success',
          title: this.visuals.datasuccess,
          body: this.visuals.submitSuccess,
        });
        this.loading = false;
        this.detailsModal.hide();
        this.search();
      },
      error: () => {
        this.loading = false;
      },
    });
  }

  handleModalOutput(event: any) {}
}
